document.addEventListener('turbo:load', () => {
  const run = document.querySelector('.likert-question');

  if (run) {

    window.atlas = window.atlas || {};
    window.atlas.likert = {};
    window.atlas.likert.reset = () => {
      resetForm();
    };
    window.atlas.likert.submitted = false;

    const closeButton = run.querySelector('.close');
    const backButton = run.querySelector('.back');
    const nextButton = run.querySelector('.next');
    const panelOne = run.querySelector('.panel-1');
    const panelTwo = run.querySelector('.panel-2');

    const closeLikertQuestionEvent = new CustomEvent('close:likert');

    closeButton.addEventListener('click', (e) => {
      e.preventDefault();

      run.classList.add('hidden');
      resetForm();

      document.dispatchEvent(closeLikertQuestionEvent);
    });

    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      let close = false;

      if(nextButton.innerText === 'SUBMIT FEEDBACK') {
        close = true;
      };

      if(panelTwo.classList.contains('hidden')) {
        panelOne.classList.toggle('hidden');
        panelTwo.classList.toggle('hidden');

        if(panelTwo.classList.contains('hidden')) {
          nextButton.innerText = 'NEXT';
        } else {
          backButton.classList.remove('invisible');
          nextButton.innerText = 'SUBMIT FEEDBACK';
        }
      }
      // JUST SUBMIT EVERYTHING EVERY TIME
      submit();

      if(close) {
        run.classList.add('hidden');

        document.dispatchEvent(closeLikertQuestionEvent);
        resetForm();
        window.atlas.notify('Thank you, your feedback has been submitted!');
        window.atlas.likert.submitted = true;
      }
    });

    const resetForm = () => {
      panelOne.classList.remove('hidden');
      panelTwo.classList.add('hidden');
      backButton.classList.add('invisible');
      nextButton.innerText = 'NEXT';
    }

    backButton.addEventListener('click', (e) => {
      e.preventDefault();
      resetForm();
    });

    const submit = () => {
      const grade = run.querySelector('#likert-grade').value;
      const topic = run.querySelector('#likert-topic').value;
      const lesson = run.querySelector('#likert-lesson').value;

      const scoreSelected = document.querySelector('input[name=likert-score]:checked');
      let score = 0;
      if(scoreSelected) {
        score = document.querySelector('input[name=likert-score]:checked').value;
      }
      const feedback = document.querySelector('#likert-feedback').value

      const payload = {
        score: {
          grade, topic, lesson, score, feedback
        }
      }

      fetch('/scores', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify(payload)
      });
    };
  }
});
